import { useState } from "react";
import { Heart, ChevronLeft, ChevronRight } from "lucide-react";
import ChannelPartnerDisclosure from "../components/common/ChannelPartnerDisclosure";

const PropertyHero = ({ property }) => {
 

  const images = property.images || [];
  const [currentIndex, setCurrentIndex] = useState(0);
 if (!property) return null;
  if (!images.length) return null;

  const next = () =>
    setCurrentIndex((i) => (i + 1) % images.length);

  const prev = () =>
    setCurrentIndex((i) => (i === 0 ? images.length - 1 : i - 1));

  return (
    <section className="max-w-7xl mx-auto p-4 grid md:grid-cols-2 gap-8">

      {/* IMAGE SECTION */}
      <div className="relative">
        <img
          src={images[currentIndex]}
          alt={property.title}
          className="rounded-2xl w-full h-[420px] object-cover"
        />

        {/* HEART */}
        <button
          type="button"
          aria-label="Save property"
          className="absolute top-3 right-3 bg-white p-2 rounded-full shadow"
        >
          <Heart size={18} />
        </button>

        {/* IMAGE COUNT */}
        <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-3 py-1 rounded">
          {currentIndex + 1} / {images.length}
        </div>

        {/* CONTROLS */}
        {images.length > 1 && (
          <>
            <button
              onClick={prev}
              type="button"
              aria-label="Show previous image"
              className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full"
            >
              <ChevronLeft />
            </button>
            <button
              onClick={next}
              type="button"
              aria-label="Show next image"
              className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full"
            >
              <ChevronRight />
            </button>
          </>
        )}
      </div>

      {/* DETAILS SECTION */}
      <div className="bg-white rounded-2xl p-6 shadow-sm space-y-6">

        {/* TITLE */}
        <div>
          <h1 className="text-2xl font-bold">{property.title}</h1>
          <p className="text-gray-600">{property.location}</p>
        </div>

        {/* PRICE */}
        {property.startingPrice && (
          <div>
            <p className="text-3xl font-bold text-blue-600">
              ₹ {property.startingPrice}
            </p>
            {property.pricePerSqft && (
              <p className="text-sm text-gray-500">
                @ ₹ {property.pricePerSqft} / sq.ft (Negotiable)
              </p>
            )}
          </div>
        )}

        {/* META INFO */}
        <div className="grid grid-cols-2 gap-4 text-sm pt-4">
          {property.bhkType && (
            <p className="text-gray-600">{property.bhkType}</p>
          )}

          {property.superBuiltUpArea && (
            <p className="text-gray-600 text-right">
              {property.superBuiltUpArea} sq.ft
            </p>
          )}

          {property.facing && (
            <p className="text-gray-600">{property.facing} Facing</p>
          )}

          {property.floor && (
            <p className="text-gray-600 text-right">
              {property.floor} Floor
            </p>
          )}
        </div>

        <ChannelPartnerDisclosure developerName={property.developerName} />

        {/* ACTION BUTTONS */}
        {(property.phone || property.whatsapp) && (
          <div className="flex gap-4 pt-6">

            {/* CALL */}
            {property.phone && (
              <a
                href={`tel:${property.phone}`}
                className="flex-1 bg-blue-600 text-white py-3 rounded-xl font-semibold text-center"
              >
                📞 Contact Owner
              </a>
            )}

            {/* WHATSAPP */}
            {property.whatsapp && (
              <a
                href={`https://wa.me/${property.whatsapp}?text=Hi,%20I%20am%20interested%20in%20your%20property%20${encodeURIComponent(
                  property.title
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 border border-green-600 text-green-600 py-3 rounded-xl font-semibold text-center"
              >
                💬 WhatsApp
              </a>
            )}
          </div>
        )}

      </div>
    </section>
  );
};

export default PropertyHero;
